import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import React, { useEffect, useRef, useState } from 'react';
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBIcon,
  MDBCollapse
} from 'mdb-react-ui-kit';

const NAVBAR_HEIGHT = 90;

export default function Navbar({ scrollTo }) {
  const [openNav, setOpenNav] = useState(false);
  const [showNav, setShowNav] = useState(true);
  const lastScroll = useRef(0);
  const THRESHOLD = 40;

  useEffect(() => {
    const onScroll = () => {
      const current = window.pageYOffset || document.documentElement.scrollTop;
      if (Math.abs(current - lastScroll.current) < THRESHOLD) return;

      if (current > lastScroll.current && current > 80) {
        setShowNav(false);
      } else {
        setShowNav(true);
      }

      lastScroll.current = current;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setOpenNav(false);
  };

  const handleNavClick = (fn) => {
    if (typeof fn === 'function') fn();
    setOpenNav(false);
  };

  return (
    <>
      <MDBNavbar
        expand="lg"
        dark
        className={`navbar-animated ${showNav ? 'nav-show' : 'nav-hide'}`}
        style={{ height: NAVBAR_HEIGHT }}
      >
        <MDBContainer fluid style={{ overflow: 'visible' }}>
          <MDBNavbarBrand onClick={scrollToTop} style={{ cursor: 'pointer' }}>
            <img
              src={`${process.env.PUBLIC_URL}/logo_sanistar-removebg-preview.png`}
              height="70"
              alt=""
            />
          </MDBNavbarBrand>

          <MDBNavbarToggler
            aria-expanded={openNav}
            aria-label="Toggle navigation"
            onClick={() => setOpenNav((s) => !s)}
          >
            <MDBIcon icon="bars" fas />
          </MDBNavbarToggler>

          <MDBCollapse navbar open={openNav} className="custom-navbar-collapse">
            <MDBNavbarNav className="me-auto mb-2 mb-lg-0">
              <MDBNavbarItem>
                <MDBNavbarLink onClick={() => handleNavClick(scrollToTop)}>Inicio</MDBNavbarLink>
              </MDBNavbarItem>

              <MDBNavbarItem>
                <MDBNavbarLink onClick={() => handleNavClick(() => scrollTo('gallery'))}>
                  Galería
                </MDBNavbarLink>
              </MDBNavbarItem>

              <MDBNavbarItem>
                <MDBNavbarLink onClick={() => handleNavClick(() => scrollTo('about'))}>
                  Acerca de nosotros
                </MDBNavbarLink>
              </MDBNavbarItem>

              <MDBNavbarItem>
                <MDBNavbarLink onClick={() => handleNavClick(() => scrollTo('time'))}>
                  Horarios
                </MDBNavbarLink>
              </MDBNavbarItem>

              <MDBNavbarItem>
                <MDBNavbarLink onClick={() => handleNavClick(() => scrollTo('services'))}>
                  Nuestros servicios
                </MDBNavbarLink>
              </MDBNavbarItem>

              <MDBNavbarItem>
                <MDBNavbarLink onClick={() => handleNavClick(() => scrollTo('contact'))}>
                  Contáctanos
                </MDBNavbarLink>
              </MDBNavbarItem>
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>

      <div style={{ height: NAVBAR_HEIGHT }} aria-hidden="true" />
    </>
  );
}
